import { p as popperGenerator } from './createPopper-5216b112.js';
import { e as eventListeners } from './modifiers/eventListeners-03086660.js';
import { p as popperOffsets } from './modifiers/popperOffsets-084f4e8a.js';
import { c as computeStyles } from './modifiers/computeStyles-e0eaf1e2.js';
import { a as applyStyles } from './modifiers/applyStyles-b7351920.js';
import { o as offset } from './modifiers/offset-21ec3e13.js';
import { f as flip } from './modifiers/flip-63c643d2.js';
import { p as preventOverflow } from './modifiers/preventOverflow-189b1ed0.js';
import { a as arrow } from './modifiers/arrow-029b39c5.js';
import { h as hide } from './modifiers/hide-be09f4e3.js';

var defaultModifiers = [eventListeners, popperOffsets, computeStyles, applyStyles, offset, flip, preventOverflow, arrow, hide];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

export { createPopper as c };
//# sourceMappingURL=popper-42aa17af.js.map
